/* eslint-disable no-unused-vars */
import { siteConfigIds } from '@/constants/site-config-ids';
import { websiteEnv } from '@/constants/website-env';
import { useEffect } from 'react';

interface Window {
  dataLayer: any[];
  gtag: (...args: any[]) => void;
}

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
    pintrk: any;
  }
}

export const useGA4 = () => {
  useEffect(() => {
    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];

    function gtag(...args: any[]) {
      window.dataLayer.push(arguments);
    }

    gtag('js', new Date());

    // Configure GA4
    // 注意:GTM 容器(tag_id 79 的 __googtag)已对同一个 GA4 属性配置了 send_page_view:true,
    // 会自动发送 page_view。这里的 gtag config 若也发 page_view,会造成同一属性双重打点
    // (page_view 被发两次),可能搅乱会话来源归因(organic 被挤成 direct)。
    // 因此这里关闭本 config 的自动 page_view,由 GTM 作为唯一 page_view 来源。
    gtag('config', siteConfigIds.ga4Id, { send_page_view: false });

    if (websiteEnv.isUnitedStates) {
      const allowConsent = () => {
        const option = {
          analytics_storage: 'granted',
          ad_storage: 'granted',
          ad_user_data: 'granted',
          ad_personalization: 'granted',
        };

        gtag('consent', 'update', option);
        localStorage.setItem('gtag.consent.option', JSON.stringify(option));
      };

      const denyConsent = () => {
        const option = {
          analytics_storage: 'denied',
          ad_storage: 'denied',
          ad_user_data: 'denied',
          ad_personalization: 'denied',
        };

        gtag('consent', 'update', option);
        localStorage.setItem('gtag.consent.option', JSON.stringify(option));
      };

      // Update consent based on user's previous choice
      const updateConsentFromLocalStorage = () => {
        const storedOption = localStorage.getItem('gtag.consent.option');

        if (storedOption) {
          const option = JSON.parse(storedOption);

          gtag('consent', 'update', option);
        } else {
          // If no stored option, default to denied for EU users
          denyConsent();
        }
      };

      // Set default consent
      gtag('consent', 'default', {
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        wait_for_update: 500,
        region: [
          'AT',
          'BE',
          'BG',
          'CY',
          'CZ',
          'DE',
          'DK',
          'EE',
          'ES',
          'FI',
          'FR',
          'GR',
          'HR',
          'HU',
          'IE',
          'IS',
          'IT',
          'LI',
          'LT',
          'LU',
          'LV',
          'MT',
          'NL',
          'NO',
          'PL',
          'PT',
          'RO',
          'SE',
          'SI',
          'SK',
          'CH',
          'GB',
        ],
      });

      gtag('set', 'ads_data_redaction', true);
      allowConsent();
    }
  }, []);
};
